import api from '@/apis/integration/integrationInvoiceBotApi.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('invoiceBot', api);

const state = {
  ...crud.state,
  _config: {
    table: 'inbot_list',
    field: {
      key: 'invoice_id',
    },
  },
};
const getters = {
  ...crud.getters,

};
const actions = {
  ...crud.actions,
  /**
  * Update lại trường hạch toán màn hình danh sách
  * @param {*} context
  * @param {*} res
  * NNLINH 24.10.2023
  */
  updatedPosted(context, res) {
    context.commit('updatedPosted', res);
  },
};
const mutations = {
  ...crud.mutations,
  /**
   * Update lại trường hạch toán ngoài màn hình danh sách
   * @param {*} state
   * @param {*} ids
   * NNLINH 24.10.2023
   */
  updatedPosted(state, payload) {
    let keyField = state._config.field.key;
    if (payload?.ids?.length) {
      payload?.ids.forEach(id => {
        for (let i = 0; i < state.items.length; i++) {
          let item = state.items[i];

          if (item[keyField] === id) {
            let itemNew = { ...item };
            if (payload?.isPosted) {
              itemNew.is_posted = payload.isPosted;
              // HMDUC2: 06/12/2023: Nếu chưa có chứng từ hoạch toán hoặc chọn chưng từ hoạch toán từ màn ChooseVoucherInvoiceBotPopup
              if(!item.refno_finance || payload?.isInvoiceBotPopup){
                itemNew.refno_finance= payload?.refNo;
              }

              //HMDUC2: 02/01/2023: Cập nhật chứng từ hoạch toán màn hình InvoiceBotList.
              if(item.refno_finance && payload?.isUpdatePosted){
                var listRefNo = item.refno_finance.split(";");
                listRefNo.forEach((refNo, index) => {
                  if(refNo === payload.refNoBeforeUpdate){
                    listRefNo[index] = payload.refNo;
                  }
                })
                itemNew.refno_finance = listRefNo.join(";");
              }
            }else {
              //HMDUC2: 02/01/2023 Nếu xóa chứng từ từ màn hình invoice_bot thì cập nhật refno_finance cho ds ở màn hình invoice_bot.
              if(payload?.refNoDelete){
                var listRefNo = item.refno_finance.split(";");
                listRefNo = listRefNo.filter((item,index) => {
                  return item != payload.refNoDelete;
                })
                itemNew.refno_finance = listRefNo.join(";");
                itemNew.is_posted = itemNew.refno_finance.length > 0 ? true : false;
              }
              //Nếu bỏ đánh dấu hạch toán xóa refNo ct liên kết
              else{
                itemNew.refno_finance = null;
                itemNew.is_posted = false;
              }
            }
            //Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
            Object.assign(item, itemNew);
            break;
          }
        }
      });
    }
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
